import React, { FC, useEffect } from 'react'
import { View, StyleSheet } from 'react-native'
import Svg, { Circle } from 'react-native-svg'
import Animated, {
  interpolate,
  SharedValue,
  useAnimatedProps,
  useSharedValue,
  withTiming
} from 'react-native-reanimated'

type PieChartProps = {
  data: PieChartDataItem[]
  centerComponent: React.ReactNode
  size?: number
  strokeWidth?: number
}

export type PieChartDataItem = {
  color: string
  percent: number
}

const AnimatedCircle = Animated.createAnimatedComponent(Circle)

export type PieChartData = PieChartDataItem[]

export const PieChartSegment: FC<{
  center: number
  radius: number
  strokeWidth: number
  color: string
  circumference: number
  angle: number
  percent: number
  progress: SharedValue<number>
}> = ({ center, radius, strokeWidth, circumference, color, angle, percent, progress }) => {
  // const animatedProps = useAnimatedProps(() => {
  //   const strokeDashoffset = interpolate(progress.value, [0, 1], [circumference, circumference * (1 - percent)])
  //   const rotateAngle = interpolate(progress.value, [0, 1], [0, angle])

  //   return {
  //     strokeDashoffset,
  //     transform: [
  //       { translateX: center },
  //       { translateY: center },
  //       { rotate: `${rotateAngle}deg` },
  //       { translateX: -center },
  //       { translateY: -center }
  //     ]
  //   }
  // })

  const strokeDashoffset = circumference * (1 - percent)
  return (
    <AnimatedCircle
      cx={center}
      cy={center}
      r={radius}
      strokeWidth={strokeWidth}
      stroke={color}
      strokeDasharray={circumference}
      originX={center}
      originY={center}
      fill={'transparent'}
      strokeDashoffset={strokeDashoffset}
      rotation={`${angle}deg`}
      // animatedProps={animatedProps}
    />
  )
}
export const PieChart = ({ data: dataProp, size = 200, strokeWidth = 20, centerComponent }: PieChartProps) => {
  const progress = useSharedValue(1)
  const center = size / 2
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const [data, startAngles] = React.useMemo(() => {
    const generatedData = [...dataProp]
    let angle = 0
    const angles: number[] = []
    generatedData.forEach((item) => {
      angles.push(angle)
      angle += item.percent * 360
    })
    return [generatedData, angles]
  }, [dataProp])

  // useEffect(() => {
  // progress.value = withTiming(1, {
  //   duration: 1000
  // })
  // }, [])

  return (
    <View style={[{ width: size, height: size }]}>
      <Svg viewBox={`0 0 ${size} ${size}`} style={styles.rotate}>
        {data
          .toSorted(() => -1)
          .map((item, index) => (
            <PieChartSegment
              key={`${item.color}-${index}`}
              center={center}
              radius={radius}
              circumference={circumference}
              angle={startAngles[index]}
              color={item.color}
              percent={item.percent}
              strokeWidth={strokeWidth}
              progress={progress}
            />
          ))}
      </Svg>
      <View style={styles.centerComponent}>{centerComponent}</View>
    </View>
  )
}

const styles = StyleSheet.create({
  titleStyle: {
    alignSelf: 'center',
    paddingBottom: 20,
    fontSize: 18,
    fontWeight: '700'
  },
  rotate: {
    transform: [{ rotateZ: '-90deg' }]
  },
  buttonWrap: { marginTop: 20 },
  centerComponent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  }
})
